// teosyalFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface internalLinking {
    heading: string;
    items: [] | any;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    internalLinking: internalLinking;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const teosyalFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Teosyal Fillers in Dubai | Elite Body Home Polyclinic",
            "description": "Get Teosyal Fillers with the best dermatologist in Dubai. Boost volume, reduce wrinkles, and enjoy safe, high-quality treatment for lasting, natural results.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/teosyal-fillers/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Teosyal Fillers in Dubai | Elite Body Home Polyclinic",
                "description": "Get Teosyal Fillers with the best dermatologist in Dubai. Boost volume, reduce wrinkles, and enjoy safe, high-quality treatment for lasting, natural results.",
                "url": "https://elitebodyhome.com/services/teosyal-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:30:21+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "teosyal filler",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Teosyal Fillers in Dubai | Elite Body Home Polyclinic",
                "description": "Get Teosyal Fillers with the best dermatologist in Dubai. Boost volume, reduce wrinkles, and enjoy safe, high-quality treatment for lasting, natural results.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Teosyal Fillers"],
        "hero": {
            "title": "Teosyal Filler in Dubai",
            "subtitle": "Refine, Revitalize, & Radiate Confidence with Teosyal Filler",
            "description": "With Teosyal Fillers, Elite Body Home, Dubai will transform your face with the best care ever. Whether you want to stimulate volume, reduce minuscule creases, or sculpt your facial pathways, our opulent practice is the perfect harbinger for your rejuvenation adventure. Results you can feel good about, safe, stunning, and natural all at once, leaving you with a glow of confidence."
        },
        "howItWorks": {
            "title": "What is Teosyal Filler?",
            "description": "Teosyal filler is an injectable treatment containing hyaluronic acid (HA): a naturally occurring substance in the skin that restores volume, smooths fine lines, and improves facial contours. This filler has a reputation for integrating well into the skin, helping create a natural look. Teosyal is especially liked for removable results and its capacity to hydrate the skin from inside."
        },
        "procedureSteps": {
            "heading": "THE STEPS OF TEOSYAL FILLER PROCESS",
            "para": "How long does a Teosyal filler treatment take? A qualified professional who specializes in facial aesthetics carries out this procedure.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "It all starts with a consultation where aesthetic goals and areas of treatment are discussed. The practitioner examines the skin condition and recommends the most suitable Teosyal filler according to patient needs.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "The target area is cleansed prior to the injection and a numbing cream may be applied to help reduce discomfort associated with the procedure.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "Injection",
                    "desc": "Following this, the filler is injected into the desired areas with the use of fine needles or cannulas. Teosyal fillers are engineered to be injected at different depths to deliver the most effective results.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Post-Injection Care",
                    "desc": "The treated areas might also be gently absorbed after injection to help distribute the filler evenly. Patients may return to normal activity immediately, but will be given some care instructions.",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages of Teosyal Filler Treatment",
            "subheading": "",
            "para": "As a comprehensive treatment, Teosyal fillers provide the aesthetic and anti-aging benefits sought by people looking to enhance their facial features without surgery. What are the advantages of Teosyal filler?",
            "items": [
                {
                    "title": "Restores Lost Volume",
                    "desc": "Teosyal is used to restore volume to sunken areas of the face, such as the cheeks, temples, and under-eye area, providing a more youthful, fuller appearance.",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "Reduces the Appearance of Fine Lines & Wrinkles",
                    "desc": "The filler works very well for smoothing wrinkles and fine lines — especially in areas like smile lines or nasolabial folds, marionette lines, and forehead wrinkles.",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "Enhances Facial Contours",
                    "desc": "Lips, chin, and jawline become more defined, giving them balanced proportions.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Hydrates & Revitalizes Skin",
                    "desc": "This is a hyaluronic acid-based injectable filler that enhances skin hydration, leaving the skin with a glowing, rejuvenated appearance.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Long-Lasting Results",
                    "desc": "Depending on the treatment area and the product used, Teosyal fillers do last 6 to 18 months.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Minimally invasive with a quick recovery",
                    "desc": "It is a non-invasive surgical procedure with very little downtime, and patients can resume normal activities almost immediately.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Is a Good Candidate for Teosyal Filler?",
            "subheading": "",
            "para": "Of course, this is just the start, there are plenty of options to tease out who is suitable, but the reality is almost anyone who is looking for facial rejuvenation or enhancement can benefit from Teosyal fillers. However, there are several factors that should be considered in determining eligibility.",
            "items": [
                {
                    "title": "Ideal Candidates",
                    "desc": "Adults age 18+ who wish to smooth the appearance of wrinkles, restore volume to the face, or add volume to facial features.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "Good General Health",
                    "desc": "Candidates must be in generally good health and should not have any active skin infections or lesions in the treatment area.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Patients must have attainable expectations regarding the results of the therapy. Teosyal does provide very marked improvements but is not a permenant solution.",
                    "icon": "fa-solid fa-scale-balanced"
                },
                {
                    "title": "Pregnancy and Nursing",
                    "desc": "Teosyal fillers are not advised for use in pregnant or lactating women.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Allergies and Sensitivities",
                    "desc": "While uncommon, be sure to talk to your provider about any history of allergies, specifically to hyaluronic acid, prior to the procedure.",
                    "icon": "fa-solid fa-allergies"
                }
            ]
        },

        "internalLinking": {
            "heading": "Explore Our Dermal Fillers for Complete Facial Enhancement",
            "items": [{ "name": "Chin Fillers", "link": "/services/chin-fillers-dubai" },
            { "name": "Nose Fillers", "link": "/services/nose-fillers-dubai" },
            { "name": "Juvederm Fillers", "link": "/services/juvederm-fillers" },
            { "name": "Jawline Fillers", "link": "/services/jawline-fillers-dubai" },
            { "name": "Teosyal Fillers", "link": "/services/teosyal-fillers" },
            { "name": "Under Eye Fillers", "link": "/services/under-eye-fillers-dubai" }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Preparing for Teosyal filler treatment process is not difficult, but it is necessary to take a few steps before moving on, so that you have the best possible results with the least risk of problems after treatment.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Avoid aspirin, ibuprofen and other blood-thinning medications for at least a week before the procedure to minimize bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Hydrate",
                    "desc": "Avoiding alcohol consumption will help keep your skin well-hydrated.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid Alcohol and Smoking",
                    "desc": "Avoid consuming alcohol and smoking for at least 24 hours before your treatment, as those can compromise healing and lead to more bruising.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Disclose Medications",
                    "desc": "Let your provider know if you are taking any medications or supplements that might interfere with the treatment.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Teosyal fillers immediately enhance the areas treated, but full results are seen within a week when any immediate swelling has reduced. Its Restorative Power Makes skin visibly smoother, hydrated, and younger while bringing back the facial contours. Results are long-lasting, with the majority of patients able to enjoy benefits for 6 to 18 months before a touch-up is required.",
            "items": [
                {
                    "title": "Additional volume and symmetry to the face",
                    "desc": "",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "Smoothing wrinkles and fine lines",
                    "desc": "",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "More defined facial features",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "The appearance of rejuvenated, youthful skin",
                    "desc": "",
                    "icon": "fa-solid fa-sparkles"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "What areas can Teosyal fillers treat?",
                    "answer": "Teosyal fillers are versatile and can be used to treat various facial areas, including the cheeks, lips, nasolabial folds, under-eye hollows, temples, and jawline."
                },
                {
                    "question": "How long do the results last?",
                    "answer": "The longevity of Teosyal filler results depends on the specific product used and the area treated, but results generally last between 6 to 18 months."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include mild swelling, redness, and bruising at the injection site, which typically resolve within a few days. Serious complications are rare but can occur if not administered properly."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "Most Teosyal fillers contain lidocaine, a local anesthetic, to minimize discomfort during the procedure. Patients typically experience minimal pain."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Results are visible immediately after the treatment, although some swelling and bruising may temporarily obscure the final outcome. Optimal results appear within a few days."
                },
                {
                    "question": "Can Teosyal fillers be reversed?",
                    "answer": "Yes, Teosyal fillers made with hyaluronic acid can be dissolved with an enzyme called hyaluronidase if needed, allowing for correction or reversal of the treatment."
                },
                {
                    "question": "How do I prepare for the treatment?",
                    "answer": "Avoid alcohol, blood thinners, and anti-inflammatory medications for at least 24-48 hours before treatment to minimize the risk of bruising and swelling."
                },
                {
                    "question": "Who is an ideal candidate for Teosyal fillers?",
                    "answer": "Ideal candidates are individuals looking to enhance facial features or reduce signs of aging without surgery. A consultation with a qualified practitioner is necessary to determine suitability."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Teosyal-Filler-in-Dubai-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/4.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/123.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Dysport-Botox-Treatment-in-Dubai-2.jpg"
            ]
        },
        "product": {
            "id": 115,
            "title": "Teosyal Dermal Fillers",
            "price": 699,
            "description": "Teosyal is a Swiss-made hyaluronic acid filler known for its smooth consistency and long-lasting results. It restores volume, smooths wrinkles, and enhances facial contours while maintaining natural expression and flexibility."
        },
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "فيلر تيوسيال في دبي | عيادة إيليت بودي هوم",
            "description": "احصل على فيلر تيوسيال مع أفضل أطباء الجلدية في دبي. استعيدي حجم بشرتك، قللي التجاعيد، واستمتعي بعلاج آمن وعالي الجودة لنتائج طبيعية ودائمة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/teosyal-fillers/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "فيلر تيوسيال في دبي | عيادة إيليت بودي هوم",
                "description": "احصل على فيلر تيوسيال مع أفضل أطباء الجلدية في دبي. استعيدي حجم بشرتك، قللي التجاعيد، واستمتعي بعلاج آمن وعالي الجودة لنتائج طبيعية ودائمة.",
                "url": "https://elitebodyhome.com/services/teosyal-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:30:21+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "فيلر تيوسيال",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "فيلر تيوسيال في دبي | عيادة إيليت بودي هوم",
                "description": "احصل على فيلر تيوسيال مع أفضل أطباء الجلدية في دبي. استعيدي حجم بشرتك، قللي التجاعيد، واستمتعي بعلاج آمن وعالي الجودة لنتائج طبيعية ودائمة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-55.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر تيوسيال"],
        "hero": {
            "title": "فيلر تيوسيال في دبي",
            "subtitle": "أبرزي ملامحك، وجددي شباب بشرتك، وتألقي بثقة مع فيلر تيوسـيال",
            "description": "تقدم لك عيادات ايليت بودي هوم في دبي تجربة فيلر تيوسيال فريدة تحول ملامح وجهك بأعلى درجات العناية. سواء كنت ترغب في استعادة الحجم، أو تقليل الخطوط الدقيقة، أو تحديد ملامح الوجه بدقة، فإن عيادتنا الفاخرة هي محطتك المثالية لبدء رحلتك نحو التجديد. ستشعرك النتائج بالرضا كما إنها آمنة، ومذهلة، وطبيعية في آنٍ واحد، تتركك ببريق من الثقة بالنفس."
        },
        "howItWorks": {
            "title": "ما هو فيلر تيوسيال؟",
            "description": "يحتوي فيلر تيوسيال القابل للحقن على حمض الهيالورونيك، وهي مادة طبيعية موجودة في الجلد تساعد على استعادة الحجم، وتنعيم الخطوط الدقيقة، وتحسين ملامح الوجه. يشتهر هذا الفيلر بقدرته العالية على الاندماج مع البشرة، مما يمنحها مظهراً طبيعياً. كما يُفضل فيلر تيوسيال لنتائجه القابلة للإزالة وقدرته على ترطيب البشرة من الداخل."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء فيلر تيوسيال",
            "para": "يُجرى هذا العلاج على يد طبيب متخصص مؤهل في التجميل غير الجراحي للوجه. إليك خطوات الإجراء:",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يبدأ العلاج بجلسة استشارية، يتم فيها مناقشة الأهداف التجميلية والمناطق التي تحتاج إلى علاج. يفحص الطبيب حالة البشرة ويوصي بنوع فيلر تيوسيال الأنسب وفقًا لاحتياجات المريض.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُنظف المنطقة المستهدفة جيدًا قبل الحقن، وقد يُستخدم كريم مخدر لتقليل أي شعور بالألم أثناء الجلسة.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "الحقن",
                    "desc": "يُحقن الفيلر باستخدام إبر أو قنيات دقيقة في المناطق المستهدفة. يُصمم فيلر تيوسيال ليُحقن على أعماق مختلفة داخل الجلد لتحقيق أفضل النتائج.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "العناية بعد الحقن",
                    "desc": "قد يقوم الطبيب بتدليك خفيف للمنطقة المُعالجة بعد الحقن لتوزيع الفيلر بشكل متساوي. يمكن للمريض العودة إلى أنشتطته المعتادة مباشرةً، مع الالتزام بتعليمات العناية التي يقدمها الطبيب.",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد فيلر تيوسيال",
            "subheading": "",
            "para": "يُعد فيلر تيوسيال من التقنيات المتكاملة التي تجمع بين الفوائد التجميلية ومقاومة علامات التقدم في العمر، وهو مثالي للأشخاص الذين يرغبون في تحسين ملامح الوجه دون اللجوء للجراحة. ما هي فوائد فيلر تيوسيال؟",
            "items": [
                {
                    "title": "استعادة الحجم المفقود",
                    "desc": "يُستخدم فيلر تيوسيال لاستعادة الحجم المفقود في مناطق الوجه الغائرة مثل الخدين، والصدغين، وتحت العين، مما يمنح الوجه مظهرًا أكثر شبابًا وامتلاءً.",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "التقليل من ظهور الخطوط الدقيقة والتجاعيد",
                    "desc": "يعمل بفعالية عالية على تنعيم التجاعيد والخطوط الدقيقة، خاصة في مناطق خطوط الابتسامة، وخطوط الماريونيت (خطوط الحزن)، وتجاعيد الجبهة.",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "تحديد ملامح الوجه",
                    "desc": "يساعد على تحديد ملامح الوجه مثل الشفاه، والذقن، وخط الفك، مما يمنحها تناسقًا وتوازنًا طبيعيًا.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "ترطيب البشرة وتجديدها",
                    "desc": "يعمل فيلر تيوسيال على تحسين ترطيب البشرة بفضل اعتماده على حمض الهيالورونيك، مما يمنحها إشراقة ونضارة صحية.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تتراوح مدة بقاء النتائج من 6 إلى 18 شهرًا، حسب المنطقة المعالجة ونوع المنتج المستخدم.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "إجراء غير جراحي ويتميز بسرعة التعافي",
                    "desc": "يتميز فيلر تيوسيال بكونه إجراء غير جراحي، ولا يتطلب فترة تعافي طويلة بعد إجرائه، ويمكن أن يسبب تورم طفيف جدًا. يستطيع المريض العودة لممارسة نشاطاته اليومية في نفس اليوم.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لفيلر تيوسيال؟",
            "subheading": "",
            "para": "يوجد العديد من العوامل التي يمكن من خلالها تحديد ما إذا كان الشخص مناسبًا لهذا النوع من الفيلر. لكن بشكل عام، فإن أي شخص يبحث عن تجديد مظهر الوجه أو تحسين ملامحه يمكن أن يستفيد من فيلر تيوسيال.",
            "items": [
                {
                    "title": "العمر",
                    "desc": "يناسب البالغون من عمر 18 عامًا أو أكثر ويرغبون في تنعيم التجاعيد، أو استعادة حجم الوجه المفقود، أو تحسين بعض ملامح الوجه مثل الشفاه أو الخدود.",
                    "icon": "fa-solid fa-user-check"
                },
                {
                    "title": "الأصحاء البالغون",
                    "desc": "يجب أن يكون الشخص في حالة صحية جيدة، وألا يعاني من التهابات أو جروج جلدية نشطة في منطقة العلاج.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "الأشخاص الذين يمتلكون توقعات واقعية",
                    "desc": "ينبغي أن تكون توقعات المريض عن النتائج واقعية. يوفر فيلر تيوسيال تحسناً واضحاً في المظهر، لكنه ليس حلاً دائمًا.",
                    "icon": "fa-solid fa-scale-balanced"
                },
                {
                    "title": "الحمل والرضاعة",
                    "desc": "لا يُنصح باستخدام فيلر تيوسيال للنساء الحوامل أو المرضعات.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحساسية",
                    "desc": "رغم ندرة ذلك، يجب إبلاغ الطبيب بأي تاريخ للحساسية، خاصة تجاه حمض الهيالورونيك، قبل الخضوع للعلاج.",
                    "icon": "fa-solid fa-allergies"
                }
            ]
        },
        "internalLinking": {
            "heading": "اكتشف مجموعتنا من فيلر البشرة لتعزيز جمال الوجه بالكامل",
            "items": [
                { "name": "فيلر الذقن", "link": "/ar/services/chin-fillers-dubai" },
                { "name": "فيلر الأنف", "link": "/ar/services/nose-fillers-dubai" },
                { "name": "فيلر جوفيديرم", "link": "/ar/services/juvederm-fillers" },
                { "name": "فيلر خط الفك", "link": "/ar/services/jawline-fillers-dubai" },
                { "name": "فيلر تيوسيال", "link": "/ar/services/teosyal-fillers" },
                { "name": "فيلر تحت العين", "link": "/ar/services/under-eye-fillers-dubai" }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يلزم تحضير بسيط جدًا قبل جلسة فيلر تيوسيال، ولكن يجب اتباع بعض الخطوات لضمان أفضل النتائج وتقليل احتمالية حدوث مضاعفات بعد الإجراء:",
            "items": [
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة لتجنب ظهور كدمات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على ترطيب الجسم",
                    "desc": "احرص على شرب كميات كافية من الماء للحفاظ على ترطيب بشرتك، فذلك يساعد على تحسين النتائج.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "الامتناع عن الكحول والتدخين",
                    "desc": "يجب الامتناع عن الكحول والتدخين لمدة 24 ساعة على الأقل قبل الجلسة، لأنهما قد يؤثران على التعافي ويرفعان من احتمالية الكدمات.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "الإفصاح عن الأدوية",
                    "desc": "أبلغ طبيبك بأي أدوية أو مكملات غذائية تتناولها، خصوصًا التي قد تتداخل مع العلاج.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر فيلر تيوسيال نتائج فورية في المناطق المعالجة، لكن النتائج النهائية تظهر خلال أسبوع تقريبًا بعد زوال التورم الطفيف الناتج عن الحقن. يمنح البشرة مظهرًا أكثر نعومة وترطيبًا، ويعيد الحيوية والنضارة لتفاصيل الوجه. تدوم النتائج من 6 إلى 18 شهرًا قبل الحاجة إلى جلسة عناية، بناءً على نوع الفيلر والمنطقة المعالجة.",
            "items": [
                {
                    "title": "يساهم في إضافة حجم وتناسق للوجه",
                    "desc": "",
                    "icon": "fa-solid fa-plus"
                },
                {
                    "title": "يعالج بفعالية الخطوط الدقيقة وتجاعيد الوجه",
                    "desc": "",
                    "icon": "fa-solid fa-minus"
                },
                {
                    "title": "يحدد ملامح الوجه بدقة",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "يمنح البشرة مظهرًا مشرقًا وممتلئًا وأكثر شبابًا",
                    "desc": "",
                    "icon": "fa-solid fa-sparkles"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "ما هي المناطق التي يمكن علاجها بفيلر تيوسيال؟",
                    "answer": "يمكن استخدام فيلر تيوسيال في علاج العديد من مناطق الوجه مثل الخدود، الشفاه، طيات الأنف والفم، تحت العينين، الصدغين، وخط الفك."
                },
                {
                    "question": "كم تدوم نتائج فيلر تيوسيال؟",
                    "answer": "تعتمد مدة بقاء النتائج على نوع المنتج المستخدم ومنطقة العلاج، ولكنها تتراوح عادة بين 6 إلى 18 شهرًا."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورمًا خفيفًا واحمرارًا وكدمات في موقع الحقن، والتي تختفي عادةً خلال بضعة أيام. المضاعفات الخطيرة نادرة ولكنها قد تحدث إذا لم يتم الحقن بشكل صحيح."
                },
                {
                    "question": "هل الإجراء مؤلم؟",
                    "answer": "يحتوي معظم فيلر تيوسيال على مخدر موضعي لتقليل الانزعاج أثناء الإجراء. يشعر المرضى عمومًا بألم بسيط."
                },
                {
                    "question": "متى ستظهر النتائج؟",
                    "answer": "تظهر النتائج فورًا بعد العلاج، على الرغم من أن التورم والكدمات قد يحجبان النتيجة النهائية مؤقتًا. تظهر النتائج المثلى خلال بضعة أيام."
                },
                {
                    "question": "هل يمكن عكس نتائج فيلر تيوسيال؟",
                    "answer": "نعم، يمكن إذابة فيلر تيوسيال المصنوع من حمض الهيالورونيك باستخدام إنزيم الهيالورونيداز إذا لزم الأمر، مما يسمح بتصحيح أو عكس العلاج."
                },
                {
                    "question": "كيف أستعد للعلاج؟",
                    "answer": "تجنب الكحول ومميعات الدم والأدوية المضادة للالتهابات لمدة 24-48 ساعة على الأقل قبل العلاج لتقليل خطر الكدمات والتورم."
                },
                {
                    "question": "من هو المرشح المثالي لفيلر تيوسيال؟",
                    "answer": "المرشحون المثاليون هم الأشخاص الراغبون في تحسين ملامح الوجه أو تقليل علامات الشيخوخة دون جراحة. يلزم استشارة مع طبيب مؤهل لتحديد الملاءمة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
};
